import { createFileRoute } from '@tanstack/react-router';
import { TenantContext } from '@interxfi/api-client';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { CreateOrganizationDrawer } from '../../../../../../features/userauth/organization/userauth-create-organization-drawer';
import { useCanUserCreateOrganization } from '../../../../../../features/userauth/organization/userauth-organization-permission-helpers';
import { UserauthOrganizationsTable } from '../../../../../../features/userauth/organization/userauth-organizations-table';
import type { RouteGuardOptions } from '../../../../../../util/routing/guard';
import { getPageHead } from '../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_platform/_context-required/organization/_organization/')({
  staticData: {
    guard: { access: { allowedTenantTypes: [TenantContext.Platform] } },
  } as const satisfies RouteGuardOptions,
  shouldReload: true,
  preload: false,
  head: () => getPageHead('Organizations'),
  component: OrganizationList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  const canCreateOrganization = useCanUserCreateOrganization();

  return (
    <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
      {canCreateOrganization ? (
        <RequiresAccess write>
          <CreateOrganizationDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Organization" size="small" />} />
        </RequiresAccess>
      ) : null}
      {filter}
    </HorizontalStack>
  );
}

function OrganizationList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <UserauthOrganizationsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
